// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login (redesign). Scoped under .rf-login so it can coexist with the
   existing .login-form rules in App.css while both pages are routed. */

.rf-login {
  --rf-ink: #191714;
  --rf-canvas: #f6f4ef;
  --rf-line: #e0dacd;
  --rf-line-2: #ddd7cb;
  --rf-muted: #8b8477;
  --rf-muted-2: #bdb6a7;
  --rf-body: #4a453c;
  --rf-gold: var(--rf-brand);
  --rf-gold-hover: var(--rf-brand-hover);
  --rf-gold-lite: var(--rf-brand-lite);
  --rf-error: #a8483e;
  --rf-error-bg: #fdf3f1;
  --rf-error-line: #f0cdc7;

  /* The route renders inside the shell's flex wrapper (.app-content),
     which sizes flex items to content — stretch to fill it. */
  width: 100%;
  min-height: 100vh;
  background: var(--rf-canvas);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  font-family: "Instrument Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: var(--rf-ink);
}
.rf-login *,
.rf-login *::before,
.rf-login *::after {
  box-sizing: border-box;
}

.rf-login-col {
  width: 352px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rf-login-logo {
  width: 212px;
  height: auto;
  display: block;
  margin-bottom: 44px;
}

.rf-login-error {
  width: 100%;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--rf-error);
  background: var(--rf-error-bg);
  border: 1px solid var(--rf-error-line);
  border-radius: 8px;
  padding: 9px 12px;
  margin-bottom: 14px;
  text-align: center;
}

.rf-login-fields {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rf-login .rf-input {
  width: 100%;
  height: 42px;
  border: 1px solid var(--rf-line);
  border-radius: 8px;
  padding: 0 13px;
  font: 400 14px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: var(--rf-ink);
  background: #fff;
  outline: none;
}
.rf-login .rf-input::placeholder {
  color: var(--rf-muted);
}
.rf-login .rf-input:focus {
  border-color: var(--rf-gold-lite);
}
.rf-login .rf-input.has-affordance {
  padding-right: 58px;
}

.rf-login .rf-input-wrap {
  position: relative;
  width: 100%;
}
.rf-login .rf-input-affordance {
  position: absolute;
  right: 13px;
  top: 13px;
  border: none;
  background: none;
  padding: 0;
  font: 600 12px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: var(--rf-muted);
  cursor: pointer;
}
.rf-login .rf-input-affordance:hover {
  color: var(--rf-body);
}

.rf-login-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 14px 0 18px;
}

.rf-login .rf-check {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.rf-login .rf-check input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.rf-login .rf-check-box {
  width: 17px;
  height: 17px;
  border-radius: 4px;
  border: 1.5px solid var(--rf-line-2);
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  color: transparent;
}
.rf-login .rf-check input:checked + .rf-check-box {
  background: var(--rf-gold);
  border-color: var(--rf-gold);
  color: #fff;
}
.rf-login .rf-check input:focus-visible + .rf-check-box {
  outline: 2px solid var(--rf-gold-lite);
  outline-offset: 2px;
}
.rf-login .rf-check-label {
  font-size: 13px;
  color: var(--rf-body);
  white-space: nowrap;
}

.rf-login .rf-link {
  border: none;
  background: none;
  padding: 0;
  font: 600 12.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: var(--rf-gold);
  cursor: pointer;
  white-space: nowrap;
}
.rf-login .rf-link:hover {
  color: var(--rf-gold-lite);
}

.rf-login-submit {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 9px;
  background: var(--rf-gold);
  color: #fff;
  font: 600 14px "Instrument Sans", Helvetica, Arial, sans-serif;
  cursor: pointer;
}
.rf-login-submit:hover {
  background: var(--rf-gold-hover);
}
.rf-login-submit:disabled {
  opacity: 0.6;
  cursor: default;
}

.rf-login-foot {
  font-size: 11.5px;
  color: var(--rf-muted-2);
  margin-top: 26px;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/login-redesign.css"],"names":[],"mappings":"AAAA;uEACuE;;AAEvE;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,oCAAoC;EACpC,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;;EAExB;8DAC4D;EAC5D,WAAW;EACX,iBAAiB;EACjB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4DAA4D;EAC5D,mCAAmC;EACnC,oBAAoB;AACtB;AACA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,8DAA8D;EAC9D,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,8DAA8D;EAC9D,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,gEAAgE;EAChE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,8DAA8D;EAC9D,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["/* Login (redesign). Scoped under .rf-login so it can coexist with the\n   existing .login-form rules in App.css while both pages are routed. */\n\n.rf-login {\n  --rf-ink: #191714;\n  --rf-canvas: #f6f4ef;\n  --rf-line: #e0dacd;\n  --rf-line-2: #ddd7cb;\n  --rf-muted: #8b8477;\n  --rf-muted-2: #bdb6a7;\n  --rf-body: #4a453c;\n  --rf-gold: var(--rf-brand);\n  --rf-gold-hover: var(--rf-brand-hover);\n  --rf-gold-lite: var(--rf-brand-lite);\n  --rf-error: #a8483e;\n  --rf-error-bg: #fdf3f1;\n  --rf-error-line: #f0cdc7;\n\n  /* The route renders inside the shell's flex wrapper (.app-content),\n     which sizes flex items to content — stretch to fill it. */\n  width: 100%;\n  min-height: 100vh;\n  background: var(--rf-canvas);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  font-family: \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  color: var(--rf-ink);\n}\n.rf-login *,\n.rf-login *::before,\n.rf-login *::after {\n  box-sizing: border-box;\n}\n\n.rf-login-col {\n  width: 352px;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.rf-login-logo {\n  width: 212px;\n  height: auto;\n  display: block;\n  margin-bottom: 44px;\n}\n\n.rf-login-error {\n  width: 100%;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--rf-error);\n  background: var(--rf-error-bg);\n  border: 1px solid var(--rf-error-line);\n  border-radius: 8px;\n  padding: 9px 12px;\n  margin-bottom: 14px;\n  text-align: center;\n}\n\n.rf-login-fields {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.rf-login .rf-input {\n  width: 100%;\n  height: 42px;\n  border: 1px solid var(--rf-line);\n  border-radius: 8px;\n  padding: 0 13px;\n  font: 400 14px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: var(--rf-ink);\n  background: #fff;\n  outline: none;\n}\n.rf-login .rf-input::placeholder {\n  color: var(--rf-muted);\n}\n.rf-login .rf-input:focus {\n  border-color: var(--rf-gold-lite);\n}\n.rf-login .rf-input.has-affordance {\n  padding-right: 58px;\n}\n\n.rf-login .rf-input-wrap {\n  position: relative;\n  width: 100%;\n}\n.rf-login .rf-input-affordance {\n  position: absolute;\n  right: 13px;\n  top: 13px;\n  border: none;\n  background: none;\n  padding: 0;\n  font: 600 12px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: var(--rf-muted);\n  cursor: pointer;\n}\n.rf-login .rf-input-affordance:hover {\n  color: var(--rf-body);\n}\n\n.rf-login-row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 14px 0 18px;\n}\n\n.rf-login .rf-check {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n.rf-login .rf-check input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.rf-login .rf-check-box {\n  width: 17px;\n  height: 17px;\n  border-radius: 4px;\n  border: 1.5px solid var(--rf-line-2);\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n  color: transparent;\n}\n.rf-login .rf-check input:checked + .rf-check-box {\n  background: var(--rf-gold);\n  border-color: var(--rf-gold);\n  color: #fff;\n}\n.rf-login .rf-check input:focus-visible + .rf-check-box {\n  outline: 2px solid var(--rf-gold-lite);\n  outline-offset: 2px;\n}\n.rf-login .rf-check-label {\n  font-size: 13px;\n  color: var(--rf-body);\n  white-space: nowrap;\n}\n\n.rf-login .rf-link {\n  border: none;\n  background: none;\n  padding: 0;\n  font: 600 12.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: var(--rf-gold);\n  cursor: pointer;\n  white-space: nowrap;\n}\n.rf-login .rf-link:hover {\n  color: var(--rf-gold-lite);\n}\n\n.rf-login-submit {\n  width: 100%;\n  height: 44px;\n  border: none;\n  border-radius: 9px;\n  background: var(--rf-gold);\n  color: #fff;\n  font: 600 14px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  cursor: pointer;\n}\n.rf-login-submit:hover {\n  background: var(--rf-gold-hover);\n}\n.rf-login-submit:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.rf-login-foot {\n  font-size: 11.5px;\n  color: var(--rf-muted-2);\n  margin-top: 26px;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
